var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BigTitle',{attrs:{"bigtitle":_vm.bigtitle}}),_c('Indicators',{attrs:{"userList":_vm.assessTargetList,"type":'batteryHolder'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }